import Vue from 'vue'

const sizes = [
  [ 'xxs', 480 ],
  [ 'xs', 544 ],
  [ 'sm', 767 ],
  [ 'md', 992 ],
  [ 'lg', 1200 ],
] as const

type SizeName = typeof sizes[number][0]

const windowSize = Vue.observable({
  width: 0,
  height: 0,

  get sizes () {
    const obj: Record<string, number> = {}
    for (const [ name, width ] of sizes) obj[name] = width
    return obj as Record<SizeName, number>
  },

  get size (): SizeName {
    const { width } = windowSize
    if (width < 480) return 'xxs'
    if (width < 768) return 'xs'
    if (width < 992) return 'sm'
    if (width < 1200) return 'md'
    return 'lg'
  },

  get isMobile () { return this.width < this.sizes.md },

})

const update = () => {
  windowSize.width = window.innerWidth
  windowSize.height = window.innerHeight
}

update()
window.addEventListener('resize', update)

export default windowSize
